import React, { useCallback, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import DashboardCard, { DashboardItem } from "./DashboardCard";
import "../styles/dashboardLanding.css";

const DashboardLanding: React.FC = () => {
  const { dashboards, loading: authLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const goToDashboard = useCallback(
    (d: DashboardItem) => {
      navigate(`/dashboard/${d.id}/${d.workspaceId}`);
    },
    [navigate],
  );

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      window.location.href = "/";
    }
    if (dashboards && dashboards.length === 1) {
      goToDashboard(dashboards[0]);
    }
  }, [isAuthenticated, authLoading, dashboards, goToDashboard]);

  return (
    <div className="page dashboard-page">
      <Navbar />

      <div className="dashboard-shell">
        <h1 className="hero-title">Dashboards</h1>

        <div className="myapps-grid">
          {authLoading && <div>Loading dashboards...</div>}

          {!authLoading && dashboards.length === 0 && (
            <div className="dashboard-empty">
              <h3 className="dashboard-empty-title">No dashboards found</h3>
              <p className="dashboard-empty-subtitle">
                If you expected to see dashboards here, check your access/role
                mapping.
              </p>
            </div>
          )}

          {!authLoading &&
            dashboards.map((d) => (
              <DashboardCard key={d.id} dashboard={d} onOpen={goToDashboard} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardLanding;
